<template>
  <ContentCardSubheader :back-to="{ name: ReviewsRouteName.ReviewsProductsIndex }">
    {{ t('Reviews.product.view.pricingTitle', { productName: product.title }) }}
    <template #actions>
      <RouterLink
        class="btn-primary-color-s"
        data-testid="reviews-pricing-edit-button"
        :to="{ name: ReviewsRouteName.ReviewsProductEditPricing, params: { productId: product.id } }"
        @click="track('profile_update_start', { surface: 'editor', entity_type: 'tool', entity_id: product.id })"
      >
        {{ t('Reviews.product.action.edit') }}
      </RouterLink>
    </template>
  </ContentCardSubheader>
</template>
<script setup lang="ts">
import { track } from '@ramp106/omrjs-tracking-reviews'
import { useI18n } from 'vue-i18n'

import type { ProductById } from '@/gql/reviews'
import { ReviewsRouteName } from '@/router/types'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'

defineProps<{
  product: Pick<ProductById, 'id' | 'title'>
}>()

const { t } = useI18n()
</script>
